import React from "react";
import { ArrowLeftIcon } from "@phosphor-icons/react";

const ChatSkeletonLoader: React.FC = () => {
  return (
    <div className="w-full h-full flex flex-col bg-white relative rounded-lg overflow-hidden">
      {/* Minimal Chat Header Skeleton. The glyph is an INERT placeholder
          (#11742 round 2.2 review): a static 30px stand-in holds the
          leading affordance's footprint until the real bar swaps in, like
          every other block in this skeleton. Round 3: the starter is a
          leaf, so the glyph mirrors the back arrow, not the hamburger. */}
      <div className="absolute top-0 left-0 right-0 z-10 max-md:static max-md:flex-none">
        <div className="bg-white px-4 py-3 flex justify-between">
          {/* Chat Title */}
          <div className="flex items-center gap-2 text-gray-800 font-semibold text-lg">
            <span
              aria-hidden="true"
              className="md:hidden flex-none w-[30px] h-[30px] -ml-1 grid place-items-center text-gray-400"
            >
              <ArrowLeftIcon size={18} />
            </span>
            <div className="w-16 h-6 bg-gray-200 rounded animate-pulse"></div>
          </div>

          {/* Profile Icon */}
          <div className="w-8 h-8 bg-gray-200 rounded-full animate-pulse"></div>
        </div>
      </div>

      {/* Main Content — desktop centers the block; at phone the composer
          skeleton docks to the bottom like the real starter (#11742 round
          3), so nothing jumps when the page swaps in. */}
      <div className="flex-1 min-h-0 flex items-center max-md:items-stretch justify-center">
        {/* mb-40 mirrors the starter's wrapper so the greeting doesn't shift
            upward the moment the real page swaps in. */}
        <div className="w-full max-w-4xl mx-auto px-6 mb-40 max-md:mb-0 max-md:h-full max-md:flex max-md:flex-col">
          <div className="text-center mb-10 max-md:mb-0 max-md:flex-1 max-md:min-h-0 max-md:flex max-md:items-center max-md:justify-center">
            {/* Greeting skeleton */}
            <div className="h-16 max-md:h-10 bg-gray-200 rounded w-96 max-w-full mx-auto mb-4 max-md:mb-0 animate-pulse"></div>
          </div>

          {/* Input bar skeleton, in flow under the greeting — the starter has
              raised it out of the viewport bottom since #11323, so a skeleton
              pinned down there would jump on load. At phone it docks with
              the round-3 inset. */}
          <div className="max-w-3xl mx-auto w-full max-md:flex-none max-md:pb-[calc(1rem+env(safe-area-inset-bottom))]">
            <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-4 w-full">
              <div className="flex items-end gap-2">
                {/* File selector button skeleton */}
                <div className="h-8 w-8 bg-gray-200 rounded-lg animate-pulse"></div>

                {/* Tools button skeleton */}
                <div className="h-8 w-8 bg-gray-200 rounded-lg animate-pulse"></div>

                {/* Textarea skeleton */}
                <div className="flex-1">
                  <div className="h-10 bg-gray-200 rounded-lg animate-pulse"></div>
                </div>

                {/* Send button skeleton */}
                <div className="h-8 w-8 bg-gray-200 rounded-lg animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatSkeletonLoader;
